import { useLayoutEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Input } from './Input';

const Prefix = styled('span')({
    whiteSpace: 'nowrap',
});

const labelSx = labelX => ({
    '& .MuiInputLabel-root': {
        transform: `translate(${labelX}px, 12px)`,
    },
    '& .MuiOutlinedInput-notchedOutline legend span': {
        padding: 0,
    },
});

export const PrefixedInput = ({ prefix, sx, ...props }) => {
    const prefixRef = useRef(null);
    const [labelX, setLabelX] = useState(null);

    useLayoutEffect(() => {
        const node = prefixRef.current;
        if (!prefix || !node) return undefined;

        const update = () => setLabelX(node.offsetLeft + node.offsetWidth);
        update();

        const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
        observer?.observe(node);
        return () => observer?.disconnect();
    }, [prefix]);

    return (
        <Input
            {...props}
            startAdornment={prefix ? <Prefix ref={prefixRef}>{prefix}</Prefix> : null}
            sx={prefix && labelX != null ? { ...labelSx(labelX), ...sx } : sx}
        />
    );
};
